import { FC } from 'react'
import { IconPaths } from '_metronic/helpers'
import { Icone } from './Icone'

/** Ícone do estado, ou `andamento` para o spinner do sistema (assinando, enviando…). */
export type Marca = IconPaths | 'andamento'

/**
 * Marca ao lado do texto de um estado. Andamento é o `spinner-border-sm` do sistema (mesmo do
 * `LoadingIndicator`): um ícone parado não diz que algo está acontecendo. Sempre decorativa.
 */
export const MarcaEstado: FC<{ marca: Marca }> = ({ marca }) =>
  marca === 'andamento' ? (
    <span aria-hidden className='spinner-border spinner-border-sm flex-shrink-0' />
  ) : (
    <Icone icone={marca} />
  )
